import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../components/AdminLayout";
import { apiRequest } from "../services/api";

function AdminAddProductPage() {
  const [product, setProduct] = useState({
    name: "",
    price: "",
    category: "",
    description: "",
    image: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();

  function handleChange(e) {
    const { name, value } = e.target;

    setProduct({
      ...product,
      [name]: value,
    });

    setMessage("");
    setError("");
  }

  function handleFileChange(e) {
    const file = e.target.files[0];
    setSelectedFile(file);
    setMessage("");
    setError("");
  }

  async function uploadImageAndGetUrl() {
    if (!selectedFile) {
      return product.image;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    const data = await apiRequest("/upload-image", {
      method: "POST",
      auth: true,
      body: formData,
    });

    if (!data.imageUrl) {
      throw new Error(data.message || "Image upload failed");
    }

    return data.imageUrl;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (
      product.name.trim() === "" ||
      product.price === "" ||
      product.category.trim() === "" ||
      product.description.trim() === ""
    ) {
      setError("Please fill all required product fields.");
      return;
    }

    try {
      setUploading(true);
      setError("");
      setMessage("");

      const imageUrl = await uploadImageAndGetUrl();

      const productData = {
        name: product.name,
        price: Number(product.price),
        category: product.category,
        description: product.description,
        image: imageUrl || "",
      };

      const data = await apiRequest("/products", {
        method: "POST",
        auth: true,
        body: productData,
      });

      setMessage(data.message);
      setProduct({
        name: "",
        price: "",
        category: "",
        description: "",
        image: "",
      });
      setSelectedFile(null);
    } catch (err) {
      if (err.status === 401 || err.status === 403) {
        navigate("/admin/login");
        return;
      }
      setError(err.message);
    } finally {
      setUploading(false);
    }
  }

  return (
    <AdminLayout title="Add Product">
      <div style={formCardStyle}>
        <form
          onSubmit={handleSubmit}
          style={{
            display: "grid",
            gap: "16px",
            maxWidth: "760px",
          }}
        >
          <div style={twoColumnStyle}>
            <input
              type="text"
              name="name"
              placeholder="Product Name"
              value={product.name}
              onChange={handleChange}
              style={inputStyle}
            />

            <input
              type="number"
              name="price"
              placeholder="Price"
              value={product.price}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>

          <div style={twoColumnStyle}>
            <input
              type="text"
              name="category"
              placeholder="Category"
              value={product.category}
              onChange={handleChange}
              style={inputStyle}
            />

            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={inputStyle}
            />
          </div>

          <textarea
            name="description"
            placeholder="Product Description"
            value={product.description}
            onChange={handleChange}
            rows="5"
            style={{ ...inputStyle, resize: "none" }}
          />

          {selectedFile && (
            <p style={{ margin: 0, color: "#374151", fontSize: "14px" }}>
              Selected image: {selectedFile.name}
            </p>
          )}

          {error && (
            <p
              style={{
                margin: 0,
                color: "#dc2626",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {error}
            </p>
          )}

          {message && (
            <p
              style={{
                margin: 0,
                color: "#16a34a",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {message}
            </p>
          )}

          <button type="submit" style={primaryButton} disabled={uploading}>
            {uploading ? "Uploading..." : "Save Product"}
          </button>
        </form>
      </div>
    </AdminLayout>
  );
}

const formCardStyle = {
  background: "white",
  borderRadius: "16px",
  padding: "25px",
  boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
  maxWidth: "760px",
};

const twoColumnStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "16px",
};

const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  borderRadius: "10px",
  border: "1px solid #d1d5db",
  outline: "none",
  fontSize: "14px",
  boxSizing: "border-box",
};

const primaryButton = {
  background: "#111827",
  color: "white",
  border: "none",
  padding: "12px",
  borderRadius: "10px",
  fontWeight: "bold",
  cursor: "pointer",
  width: "180px",
};

export default AdminAddProductPage;
